import type { Node } from "@xyflow/react";

// ═══ BAND 6 · TOPIC ANALYSIS ═══════════════════════════════════════════════════
// Leo's synthesis of the 234-article corpus, placed IMMEDIATELY to the RIGHT of the
// Article Research wall (band5). band5: X0=10500, 26 columns @ COL_PITCH=600 → last
// column x=25500, right edge ~25940. This card starts at x=26800 (~860px clear gap)
// and top-aligns with the Article Research band super-title at y=-1300. Single
// self-contained `analysisCard` node. Content is Leo's final analysis — rendered
// verbatim, no invented numbers.

export function band6TopicAnalysis(): Node[] {
  const X = 26800;
  const Y = -1300;
  return [
    {
      id: "topic-analysis",
      type: "analysisCard",
      position: { x: X, y: Y },
      data: {
        title: "Topic Analysis",
        sub: "What the field talks about — 234 articles across 26 sources, ranked by frequency",
        maxCount: 57,
        bars: [
          { rank: 1, label: "AI Agents — build / deploy / use", note: "incl. 21 customer-service / contact-center", count: 57, pct: "24%" },
          { rank: 2, label: "State of AI / trends / predictions", count: 41, pct: "17%" },
          { rank: 3, label: "Enterprise adoption / implementation", count: 25, pct: "11%" },
          { rank: 4, label: "SEO / GEO / AI search visibility", count: 21, pct: "9%" },
          { rank: 5, label: "Prompting / how-to-use / tutorials", count: 21, pct: "9%" },
          { rank: 6, label: "AI for marketing", count: 19, pct: "8%" },
          { rank: 7, label: "Jobs / future of work / economy", count: 18, pct: "8%" },
          { rank: 8, label: "Coding / vibe-coding / dev tools", count: 13, pct: "6%" },
          { rank: 9, label: "Product mgmt / building AI products", count: 12, pct: "5%" },
          { rank: 10, label: "Startup ideas / opportunity", count: 11, pct: "5%" },
          { rank: 11, label: "Value / ROI / the impact gap", count: 7, pct: "3%" },
          { rank: 12, label: "Pricing / economics of AI", count: 6, pct: "3%" },
          { rank: 13, label: "Governance / safety / guardrails", count: 5, pct: "2%" },
          { rank: 14, label: "Voice AI", count: 5, pct: "2%" },
          { rank: 15, label: "Data readiness / knowledge foundation", count: 2, pct: "1%", gap: true },
        ],
        saturated: {
          heading: "Saturated — owned, don't fight",
          note: "The big labs, VCs & Single Grain already own these.",
          items: ["AI Agents", "State of AI / trends", "SEO / GEO", "Prompting how-tos"],
        },
        whitespace: {
          heading: "White space — open + ours",
          note: "Barely covered anywhere — this is the opening.",
          items: [
            "Getting your DATA ready (~0%)",
            "Real ROI / proof of value",
            "Governance for operators",
            "Actually RUNNING a live system",
          ],
        },
        lane: {
          heading: "Our lane",
          body: "Everyone talks ABOUT agents and the value gap — almost nobody shows how you get messy business data ready, then run a real system on it. That's step one of what we do, and it's an empty lane.",
          bold: "Our topic: the operator's guide — get your data ready → put agents on it → proven with real, anonymized teardowns.",
        },
        w: 1040,
      },
      draggable: false,
      selectable: false,
    },
  ];
}
